@if (showTopControls) {
  <div
    class="mbs-accordion_controls"
    [class.-sm]="size === 'sm' || size === 'small'"
    [class.-lg]="size === 'lg' || size === 'large'">
    <div class="row align-items-center justify-content-between">
      <div class="col-auto mbs-accordion_controls-checkbox">
        <mbs-checkbox
          [checked]="checkedTop"
          [indeterminate]="indeterminateTop"
          [label]="topControlsLabel"
          (change)="topControlsCheckboxChangeHandler($event); handleCountTotalSelected()" />
      </div>

      @if (topControlsDescription) {
        <div class="col-auto mbs-accordion_controls-description">
          {{ topControlsDescription }}
        </div>
      }
    </div>
  </div>
}

<ng-template #topControlsLabel>
  <ng-template [ngTemplateOutlet]="topControlsPrependLabel?.template" />

  @if (topControlsLabelSelected) {
    <span>
      {{ selectedInAllPanels }}
    </span>
  }

  <ng-template [ngTemplateOutlet]="topControlsAppendLabel?.template" />
</ng-template>

<div
  #innerAccordion="ngbAccordion"
  ngbAccordion
  class="mbs-accordion"
  [closeOthers]="closeOthers"
  [destroyOnHide]="destroyOnHide"
  [class.mbs-accordion-checkboxes]="checkboxes"
  [class.mbs-accordion-onepanel]="panels.length === 1"
  [class.mbs-accordion-simple]="!isDefaultView"
  [class.mbs-accordion-sm]="size === 'small'"
  [class.overflow-auto]="!!maxHeight"
  [class.-narrow-header]="narrowHeader"
  [class.-showControls]="showTopControls"
  [class.-without-border]="withoutBorder"
  [style.max-height]="maxHeight"
  (hidden)="onPanelHidden($event)"
  (show)="onPanelChange($event)">
  @for (panel of panels; track panel?.id ?? panel) {
    @if (panel.shown) {
      <div
        [collapsed]="!isOpenedPanel(panel.id)"
        [disabled]="panel.disabled"
        [id]="panel.id"
        [ngbAccordionItem]="panel.id"
        #item="ngbAccordionItem">
        @if (!panel.hideHeader) {
          <div
            ngbAccordionHeader
            class="accordion-button"
            [ngClass]="panel.headerCustomClasses">
            @if (isDefaultView) {
              <!-- TODO: need refactored after update bootstrap to v5.3.0. Will be use [cardClass]='some classes' instead onClickHeaderPanel() -->
              <header
                class="mbs-accordion_header"
                [class.background-light]="checkboxes"
                (click)="onClickHeaderPanel($event, innerAccordion.isExpanded(panel.id))">
                @if (arrow && !panel.panelIconHeader) {
                  <div
                    class="ctrl mbs-accordion_toggler"
                    [class.-checkboxes]="checkboxes"
                    [class.-collapsed]="
                      panel.disabled ? !panel.keepOpened && !innerAccordion.isExpanded(panel.id) : !innerAccordion.isExpanded(panel.id)
                    "
                    [class.-disabled]="panel.disabled"
                    [class.-sm]="size === 'small'">
                    <button
                      class="ctrl mbs-accordion_toggler-btn"
                      [disabled]="panel.disabled"
                      ngbAccordionToggle></button>
                  </div>
                }

                @if (panel.panelIconHeader) {
                  <div
                    class="mbs-accordion_ico"
                    [class.-align-left]="align === 'left'">
                    <span
                      class="mbs-accordion_ico-img"
                      [class.-disabled]="panel.disabled">
                      <ng-template [ngTemplateOutlet]="panel.panelIconHeader.template" />
                    </span>

                    <button
                      class="ctrl mbs-accordion_ico-btn"
                      [disabled]="panel.disabled"
                      ngbAccordionToggle></button>
                  </div>
                }

                @if (checkboxes) {
                  <div [class.mbs-accordion_header-checkbox]="!panel.hideCheckboxes">
                    <div class="row flex-nowrap g-0">
                      @if (!panel.hideCheckboxes) {
                        <mbs-checkbox
                          class="col-auto"
                          [checked]="panel.selectedAll"
                          [disabled]="panel.disabled"
                          [id]="panel.id + $index"
                          [indeterminate]="panel.indeterminate"
                          (change)="handleChangePanelHeaderCheckbox($event, panel); countTotalSelected(); handleCountTotalSelected()" />
                      }

                      <button
                        class="ctrl ctrl-dark mbs-accordion_title col-auto"
                        [ngClass]="toggleButtonClass"
                        ngbAccordionToggle>
                        @if (panel.title; as title) {
                          {{ title }}
                        } @else {
                          <ng-template [ngTemplateOutlet]="panel.titleTemplate" />
                        }
                      </button>

                      @if (!panel.hideCheckboxes) {
                        <button
                          class="ctrl d-flex flex-nowrap justify-content-end col-auto"
                          [ngClass]="toggleButtonClass"
                          ngbAccordionToggle>
                          <span class="small text-muted text-nowrap pl-3 col-auto"> Selected: {{ panel.selectedCount }} </span>
                          <span class="small text-muted text-nowrap pl-3 col-auto"> Total: {{ panel.all }} </span>
                        </button>
                      }
                    </div>
                  </div>
                }

                @if (panel.prependHeaderTemplate; as template) {
                  <ng-template
                    item-panel="panel"
                    [ngTemplateOutlet]="template" />
                }

                @if (!checkboxes) {
                  <button
                    class="ctrl ctrl-dark mbs-accordion_title"
                    [ngClass]="toggleButtonClass"
                    ngbAccordionToggle>
                    @if (panel.title; as title) {
                      {{ title }}
                    } @else {
                      <ng-template [ngTemplateOutlet]="panel.titleTemplate" />
                    }
                  </button>
                }

                @if (panel.appendHeaderTemplate; as template) {
                  <ng-template
                    item-panel="panel"
                    [ngTemplateOutlet]="template" />
                }
              </header>
            } @else {
              <header
                class="mbs-accordion_header"
                (click)="onClickHeaderPanel($event, innerAccordion.isExpanded(panel.id))">
                @if (arrowPosition === 'left') {
                  <ng-container [ngTemplateOutlet]="arrowTmp" />
                }

                @if (panel.panelIconHeader) {
                  <div class="mbs-accordion_ico">
                    <span
                      class="mbs-accordion_ico-img"
                      [class.-disabled]="panel.disabled">
                      <ng-template [ngTemplateOutlet]="panel.panelIconHeader.template" />
                    </span>

                    <button
                      ngbAccordionToggle
                      class="ctrl mbs-accordion_ico-btn"
                      [disabled]="panel.disabled"></button>
                  </div>
                }

                <button
                  ngbAccordionToggle
                  class="ctrl mbs-accordion_title"
                  [class.ctrl-primary]="isTitlePrimary"
                  [class.toggleButtonClass]="true">
                  @if (panel.title; as title) {
                    {{ title }}
                  } @else {
                    <ng-template [ngTemplateOutlet]="panel.titleTemplate" />
                  }
                </button>

                @if (arrowPosition === 'right') {
                  <ng-container [ngTemplateOutlet]="arrowTmp" />
                }

                <ng-template #arrowTmp>
                  @if (arrow) {
                    <div
                      class="ctrl mbs-accordion_toggler"
                      [class.ctrl-primary]="isTitlePrimary"
                      [class.pl-2]="arrowPosition === 'right'"
                      [class.pr-2]="arrowPosition === 'left'"
                      [class.-collapsed]="
                        panel.disabled ? !panel.keepOpened && !innerAccordion.isExpanded(panel.id) : !innerAccordion.isExpanded(panel.id)
                      "
                      [class.-disabled]="panel.disabled"
                      [class.-sm]="size === 'small'">
                      <button
                        ngbAccordionToggle
                        class="ctrl mbs-accordion_toggler-btn"
                        [disabled]="panel.disabled"></button>
                    </div>
                  }
                </ng-template>
              </header>
            }
          </div>
        }

        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              @if (isDefaultView) {
                @if (xScroll) {
                  <div class="ng-scroll-content">
                    <ng-container [ngTemplateOutlet]="accordionPanelContent" />
                  </div>
                } @else {
                  <ng-container [ngTemplateOutlet]="accordionPanelContent" />
                }

                <ng-template #accordionPanelContent>
                  <div
                    [class]="customContentClasses"
                    [class.mbs-accordion-checkboxes_content]="checkboxes"
                    [class.mbs-accordion_content]="!checkboxes">
                    @if (panel.rowTemplate) {
                      @for (item of panel.rows; track item) {
                        <div
                          class="mbs-accordion-checkboxes_row"
                          [class.-disabled]="item.disabled"
                          [class.-selected]="item.checked">
                          @if (checkboxes && !panel.hideCheckboxes) {
                            <mbs-checkbox
                              [checked]="item.checked"
                              [disabled]="panel.disabled || item.disabled"
                              [label]="labelMode === 'check' ? panel.rowTemplate.template : null"
                              [labelContext]="labelMode === 'check' ? item.data : null"
                              (change)="panel.checkPanelCheckboxStatus($event, item); countTotalSelected(); handleCountTotalSelected()" />
                          }

                          @if (labelMode === 'toggle') {
                            <div
                              [class.mbs-accordion-checkboxes_row-label.overflow-hidden]="!panel.hideCheckboxes"
                              [class.w-100]="panel.fullWidthLabel">
                              <ng-container
                                [ngTemplateOutlet]="panel.rowTemplate.template"
                                [ngTemplateOutletContext]="{ $implicit: item.data }" />
                            </div>
                          }
                        </div>
                      }
                    }
                    @if (!checkboxes) {
                      <ng-template [ngTemplateOutlet]="panel.bodyTemplate" />
                    }
                  </div>
                </ng-template>
              } @else {
                <div
                  class="mbs-accordion_content"
                  [class]="customContentClasses"
                  [class.pl-0]="!panel.panelIconHeader">
                  <ng-template [ngTemplateOutlet]="panel.bodyTemplate" />
                </div>
              }
            </ng-template>
          </div>
        </div>
      </div>
    }
  }
</div>
